import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext } from '@tencent/glue-react-use';

var _createContext = createContext(null),
    _createContext2 = _slicedToArray(_createContext, 2),
    Provider = _createContext2[0],
    useSelect = _createContext2[1];

export var useSelectInstance = useSelect;
export var SelectProvider = Provider;